/* eslint-disable no-extra-boolean-cast */
/* eslint-disable no-unused-vars */
import { apiClient } from "../../config/api.config";
import {
  setSession,
  setUser,
  userLoggedOut,
} from "../../store/slices/authSlice";
import store from "../../store/index";
import { useSelector } from "react-redux";
import ToastController from "../ToastController";
import NotificationController from "../NotificationController";

class AuthController {
  //

  static adminLogin(data) {
    console.log("@data....", data);
    return new Promise((resolve, reject) => {
      apiClient
        .post("/admin/auth/login", data)
        .then((res) => {
          console.log(res, "@login res api...");
          if (res?.data?.success) {
            resolve(res?.data?.data);
          } else {
            reject(res?.data);
          }
        })
        .catch((err) => {
          console.log("@auth error....", err);
          reject(err);
        });
    });
  }

  static notification(data) {
    console.log("@dataNotification....", data);
    delete data?.general;
    return new Promise((resolve, reject) => {
      apiClient
        .patch("/admin/auth/notifications-preferences", data)
        .then((res) => {
          console.log(res, "@Notification res api...");
          if (res?.data?.success) {
            resolve(res?.data?.data);
          } else {
            reject(res?.data);
          }
        })
        .catch((err) => {
          console.log("@notification error....", err);
          reject(err);
        });
    });
  }

  static updateServiceFee(data) {
    const formatedData = {
      serviceFee: data?.serviceFee,
    };
    console.log(formatedData, "@data...");
    return new Promise((resolve, reject) => {
      apiClient
        .patch(`/admin/auth/update-service-fee`, formatedData)
        .then((res) => {
          console.log(
            res?.data?.data,
            res?.data?.success,
            "@service update res api"
          );
          // store.dispatch(setUpdateAthlete(res?.data?.data));
          if (res?.data?.success) {
            resolve(res?.data?.data);
          } else {
            reject(res?.data);
          }
        })
        .catch((err) => {
          console.log("@service update error....", err);
          reject("Network error");
        });
    });
  }
  static getAwsEnums(data) {
    console.log("@data....", data);
    return new Promise((resolve, reject) => {
      apiClient
        .get("/user/auth/app-envs", data)
        .then((res) => {
          console.log(res, "@awsEnum res api");
          if (res?.data?.success) {
            resolve(res?.data?.data);
          } else {
            reject(res?.data);
          }
        })
        .catch((err) => {
          console.log("@awsEnum error....", err);
          reject(err);
        });
    });
  }
  static persistCredentials = (session, awsEnumsData = {}) => {
    if (!!session) {
      // session?.user && MySocketController.init();
      // console.log(enumsData, 'what is enumsdta')
      const mergedSession = { ...session, ...awsEnumsData };

      store.dispatch(setSession(mergedSession));
      store.dispatch(setUser(mergedSession));
      // store.dispatch(setSession(session));
      // store.dispatch(setUser(session));
      apiClient.defaults.headers.common["Authorization"] = session?.token;
      localStorage?.setItem(
        "Corsa-Athletics-Admin.v.0.1",
        JSON.stringify(mergedSession)
      );
      // localStorage?.setItem(
      //   "Corsa-Athletics-Admin.v.0.1",
      //   JSON.stringify(session)
      // );
    }
  };
  static getPersistedCredentials = () => {
    let strSessionData = localStorage?.getItem("Corsa-Athletics-Admin.v.0.1");
    if (strSessionData) {
      return JSON.parse(strSessionData);
    } else {
      return null;
    }
  };

  static restorePersistedCredentials() {
    let persistedData = AuthController.getPersistedCredentials();
    // if (persistedData?.user) {
    //   MySocketController.init();
    // }
    console.log(persistedData, "@persisted data.!");
    if (persistedData) {
      store.dispatch(setSession(persistedData));
      apiClient.defaults.headers.common["Authorization"] = persistedData?.token;
      return persistedData?.user;
    } else {
      return false;
    }
  }
  static async logout() {
    // const user = store.getState().Auth.session?.user;
    // const firebaseToken = store.getState().Notification.fireBaseToken;
    try {
      // ToastController.info("Logging Out!");
      await store.dispatch(userLoggedOut());

      ToastController.info("Logged Out Successfully!");
      let session = AuthController.getPersistedCredentials();
      NotificationController.removeFcmToken(session?.fcm_token);
      localStorage?.removeItem("Corsa-Athletics-Admin.v.0.1");
      store.dispatch(setSession(null));
      apiClient.defaults.headers.common["Authorization"] = undefined;
    } catch (error) {
      store.dispatch(setSession(null));
      localStorage?.removeItem("Corsa-Athletics-Admin.v.0.1");
      store.dispatch(userLoggedOut());
      apiClient.defaults.headers.common["Authorization"] = undefined;

      ToastController.info("Network Error!");
    }
  }
}

export default AuthController;

export const useAuth = () => {
  const session = useSelector((state) => state.Auth.session);
  console.log(session, "@session useAuth");
  // const isTourComplete = localStorage.getItem("isTourComplete");
  // const isPending =
  //   session?.user?.accountStatus === EnumsController.ACCOUNT_STATUS.PENDING;

  // const loginRedirect = isPending
  //   ? session?.code === 201
  //     ? "/establish-profile"
  //     : "/home"
  //   : "/home";
  // const logOutRedirect = "/";

  return {
    user: session?.admin,
    token: session?.token,
    authenticated: session?.token && session?.admin ? true : false,
    session,

    // loginRedirect,
    // logOutRedirect,
  };
};
